const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      const safeReport = (fn) => {
        try { fn(onPerfEntry); } catch (e) {
          if (e?.message !== 'Timeout') console.warn('[web-vitals]', e);
        }
      };
      safeReport(getCLS);
      safeReport(getFID);
      safeReport(getFCP);
      safeReport(getLCP);
      safeReport(getTTFB);
    }).catch((e) => {
      if (e?.message !== 'Timeout') console.warn('[web-vitals] load:', e);
    });
  }
};

export default reportWebVitals;
